import React, { Component } from "react";
import { Form, Image } from "react-bootstrap";
import { DatePicker } from "../../component/DatePicker";
import connect from "react-redux/es/connect/connect";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router-dom";
import "rc-time-picker/assets/index.css";
import TimePicker from "rc-time-picker";
import { Field } from "../../component";
import { get } from "lodash";
import { getLocalstorage } from "../../helper";
import moment from "moment";
import { MEETING_OPTION } from "../../constant";
import OptionsField from "../../component/InputFieldLayout/SelectOptionsField";
import RadioButtonLayout from "../../component/InputFieldLayout/radioButtonLayout";
import Clock from "../../assets/clock.svg";
import CustomDropdown from "../reusableComponent/Dropdown/CustomDropdown";
export class CreateAgendaForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      meetingType: ""
    };
  }
  onChange = (key, value) => {
    this.props.onChange(key, value);
  };

  onStartTimeChange = time => {
    time && this.props.onChange("meetingTimeFrom", time);
  };

  onEndTimeChange = time => {
    time && this.props.onChange("meetingTimeTo", time);
  };

  onFieldChange = (value, key) => {
    this.props.onChange(key, value);
    debugger;
  };

  onFieldError = (value, key) => {
    this.props.onError(key, value);
  };

  onDecisionDropdownSelect = (event, name) => {
    console.log(event, name);

    // this.setState({ meetingType: event.target.value });
    this.props.onChange(name, event.value);
  };
  onSelectedField = (event, name) => {
    this.props.onChange(name, event);
  };
  onMeetingModeChange = value => {
    this.props.onChange("meetingMode", value.target.name);
  };
  onBlur = value => {};
  render() {
    const {
      venues,
      agendaSenders,
      meetingModesOptions,
      formData,
      error,
      validateField,
      agendaMeetingTypeDetails
    } = this.props;
    const { groupCategory } = getLocalstorage("user") || {};
    const { meetingType } = this.state;
    const meetingModeList =
      meetingModesOptions &&
      meetingModesOptions.length &&
      meetingModesOptions.map((item, index) => {
        return {
          id: item,
          name: MEETING_OPTION[item]
        };
      });
    const imageClock = <Image className="clock-image" src={Clock} />;
    return (
      <React.Fragment>
        <div className="create-agenda-form-wrapper">
          <h2 className="page-orange-bar">Agenda Details</h2>
          <Form className="create-agenda-form">
            <Form.Group className="agenda-field-datepicker">
              <div className="field-label-wrapper">
                <Form.Label>
                  Meeting Date<span className="required">*</span>
                </Form.Label>
              </div>
              <div className="form-field">
                <DatePicker
                  selected={formData.meetingDate}
                  //minDate={new Date()}
                  onChange={value => this.onChange("meetingDate", value)}
                />
              </div>
            </Form.Group>
            <Form.Group className="meeting-time">
              <div className="start-time">
                <Form.Label>
                  Meeting Start Time<span className="required">*</span>
                </Form.Label>
                <div className="form-field">
                  <TimePicker
                    showSecond={false}
                    value={formData.meetingTimeFrom}
                    className={`${
                      error.meetingTimeFrom &&
                      error.meetingTimeFrom.error &&
                      !formData.meetingTimeFrom
                        ? "is-invalid-time-field"
                        : ""
                    }`}
                    onChange={this.onStartTimeChange}
                    format={"h:mm a"}
                    use12Hours
                    inputReadOnly
                    minuteStep={15}
                    allowEmpty={false}
                    inputIcon={imageClock}
                  />
                  {error.meetingTimeFrom &&
                    error.meetingTimeFrom.error &&
                    !formData.meetingTimeFrom && (
                      <div class="invalid-feedback">
                        {get(error, "meetingTimeFrom.message")}
                      </div>
                    )}
                </div>
              </div>
              <div
                className={`${
                  error.meetingTimeFrom &&
                  error.meetingTimeFrom.error &&
                  !formData.meetingTimeFrom
                    ? "end-time-padding"
                    : ""
                } end-time`}
              >
                <Form.Label>Meeting End Time</Form.Label>
                <div className="form-field">
                  <TimePicker
                    showSecond={false}
                    value={formData.meetingTimeTo}
                    className="xxx"
                    onChange={this.onEndTimeChange}
                    format={"h:mm a"}
                    use12Hours
                    inputReadOnly
                    minuteStep={15}
                    allowEmpty={false}
                    inputIcon={imageClock}
                  />
                </div>
              </div>
            </Form.Group>
            <Form.Group className={"field-select"}>
              <div className="field-label-wrapper">
                <Form.Label>
                  Agenda Name<span className="required">*</span>
                </Form.Label>
                <Form.Text className="field-description">
                  e.g.{" "}
                  {groupCategory === "STATE_PMG"
                    ? "District/Forest department"
                    : "Haryana State/Railway Subgroup Meeting"}
                </Form.Text>
              </div>
              <Field
                keyName="agendaName"
                type="text"
                value={formData.agendaName}
                onChange={this.onFieldChange}
                onError={this.onFieldError}
                onBlur={() => validateField("agendaName", formData.agendaName)}
                isInvalid={get(error, "agendaName.error")}
                placeholder="Enter Agenda Name"
              />
              <Form.Control.Feedback type="invalid">
                {get(error, "agendaName.message")}
              </Form.Control.Feedback>
            </Form.Group>
            <div className="meeting-type">
              <OptionsField
                optionsList={
                  agendaMeetingTypeDetails !== null
                    ? agendaMeetingTypeDetails
                    : ""
                }
                name="meetingType"
                label={"Meeting Type"}
                className="meeting-type"
                value={meetingType}
                isRequiredField={true}
                formData={formData.meetingType}
                onChange={this.onDecisionDropdownSelect}
                placeholderName={"meeting type"}
                onSelectedField={this.onSelectedField}
                showRequiredError={error.meetingType}
                isTopMarginRequired={false}
                error={
                  error.meetingType &&
                  error.meetingType.error &&
                  !formData.meetingType
                }
              />
              {error.meetingType &&
                error.meetingType.error &&
                !formData.meetingType && (
                  <div class="invalid-feedback">
                    {get(error, "meetingType.message")}
                  </div>
                )}
            </div>
            <Form.Group className={"field-select"}>
              <div className="field-label-wrapper">
                <Form.Label>
                  Meeting Chaired By<span className="required">*</span>
                </Form.Label>
              </div>
              <Field
                keyName="meetingChairedBy"
                type="text"
                placeholder="Enter meeting chaired by"
                value={formData.meetingChairedBy}
                onChange={this.onFieldChange}
                onError={this.onFieldError}
                onBlur={() =>
                  validateField("meetingChairedBy", formData.meetingChairedBy)
                }
                isInvalid={get(error, "meetingChairedBy.error")}
              />
              <Form.Control.Feedback type="invalid">
                {get(error, "meetingChairedBy.message")}
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group className="field-select">
              <Form.Label>
                Meeting Venue<span className="required">*</span>
              </Form.Label>
              <div className="form-field">
                {/* <CustomDropdown
                  options={[
                    {
                      value: "Choose Venue",
                      label: "Choose Venue",
                      id: ""
                    },
                    ...(venues || []).map(item => ({
                      value: item.id,
                      label: item.name,
                      id: item.id
                    }))
                  ]}
                  width={"100%"}
                  height={"43px"}
                  className={`dashboard ${
                    get(error, "venue.message")
                      ? "create-agenda mandatory-error"
                      : ""
                  }`}
                  page={"create-agenda-form-venue-dropdown"}
                  menuClassName={"venue-dropdown-menu"}
                  value={
                    ((venues || []).find(i => i.id === formData.venue) || {})
                      .name || null
                  }
                  onChange={this.onFieldChange}
                  onBlur={this.onBlur}
                /> */}
                <Field
                  className={`${
                    formData.venue === "" ? "color-of-placeholder" : ""
                  }`}
                  as="select"
                  key="venue"
                  keyName="venue"
                  value={formData.venue || null}
                  onChange={this.onFieldChange}
                  onError={this.onFieldError}
                  isInvalid={get(error, "venue.error")}
                  onBlur={this.onBlur}
                >
                  <option value="">Choose Venue</option>
                  {(venues || []).map(value => {
                    return (
                      <option value={value.id} key={value.id}>
                        {value.name}
                      </option>
                    );
                  })}
                </Field>
                <Form.Control.Feedback type="invalid">
                  {get(error, "venue.message")}
                </Form.Control.Feedback>
              </div>
            </Form.Group>
            <div className="input-fields meeting-mode-buttons d-flex">
              <RadioButtonLayout
                label={"Meeting Mode"}
                className="meeting-mode"
                isRequiredField={true}
                name="VIDEO_CONFERENCE"
                onChange={this.onMeetingModeChange}
                toggleLableName="Video conference"
                formData={formData.meetingMode}
                isFromAgendaDeatil={true}
              />

              <RadioButtonLayout
                className="meeting-mode ml-4 in-person-button"
                name="IN_PERSON"
                onChange={this.onMeetingModeChange}
                toggleLableName="In-person"
                radioButtonMarginWithoutLabel={true}
                formData={formData.meetingMode}
              />
            </div>
          </Form>
        </div>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    pageDetail: state.createProjectReducer.pageDetail,
    isImageUpLoading: state.commonReducer.isImageUpLoading,
    issuesCategoryList: state.commonReducer.issuesList,
    isLoading: state.createProjectReducer.isLoading
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({}, dispatch);
}

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(CreateAgendaForm)
);
